/**
 * 水印生成工具函数（彻底解决手机号截断问题）
 */
const addWatermark = ({
    container = document.body,
    canvasWidth = 300, // 大幅加宽Canvas：从240→300px，确保旋转后仍有足够空间
    canvasHeight = 120, // 加高Canvas：从100→120px
    fontSize = 16, // 字体大小
    fillStyle = "rgba(184, 184, 184, 0.3)",
    content = "", // 完整11位手机号
    rotate = -25, // 旋转角度
    zIndex = 10000,
}) => {
    // 1. 移除旧水印
    const oldWm = document.querySelector(".__wm");
    if (oldWm) oldWm.remove();

    // 2. 空内容校验
    if (!content || content.length !== 11) return;

    // 3. 创建Canvas（使用数字尺寸，避免parseFloat转换误差）
    const canvas = document.createElement("canvas");
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    // 4. 核心优化：重新计算绘制位置，避免旋转截断
    const font = `${fontSize}px Microsoft Yahei`;
    ctx.font = font;
    // 获取文字实际宽度
    const textWidth = ctx.measureText(content).width;
    // 计算旋转后的文字偏移量（关键：让文字在Canvas正中央，且不超出边界）
    const radian = (Math.PI / 180) * rotate;
    // 旋转中心移到Canvas正中央
    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate(radian);
    // 绘制文字：向左偏移文字宽度的一半，确保水平居中且不截断
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillStyle = fillStyle;
    ctx.fillText(content, 0, 0); // 基于旋转后的中心绘制，而非Canvas原始中心

    // 5. 生成水印DOM
    const base64Url = canvas.toDataURL("image/png");
    const watermarkDiv = document.createElement("div");
    watermarkDiv.className = "__wm";
    // 关键：背景不拉伸，按Canvas原始尺寸重复，且设置足够的背景尺寸避免压缩
    watermarkDiv.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100vw;
      height: 100vh;
      z-index: ${zIndex};
      pointer-events: none;
      background-image: url('${base64Url}');
      background-repeat: repeat;
      background-size: ${canvasWidth}px ${canvasHeight}px; // 严格匹配Canvas尺寸
      background-position: 0 0;
    `;

    // 6. 容错添加到容器
    const targetContainer = container instanceof HTMLElement ? container : document.body;
    targetContainer.appendChild(watermarkDiv);

    // 7. 监听DOM变化，防止水印被删除
    if (window.MutationObserver && !targetContainer.__watermarkObserver) {
        const mo = new MutationObserver(() => {
            const currentWm = document.querySelector(".__wm");
            if (!currentWm || currentWm.style.backgroundImage !== watermarkDiv.style.backgroundImage) {
                addWatermark({ container, canvasWidth, canvasHeight, fontSize, fillStyle, content, rotate, zIndex });
            }
        });
        mo.observe(targetContainer, { attributes: true, subtree: true, childList: true });
        targetContainer.__watermarkObserver = mo;
    }
};

/**
 * 更新水印：确保DOM加载完成后执行
 */
export const updateWatermark = (customContent) => {
    const currentDomain = window.location.hostname;
    if (currentDomain !== 'https://neigou-admin.lanmonshop.com') return
    const init = () => {
        const content = customContent || (() => {
            const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
            return user.phone || "";
        })();

        addWatermark({
            container: document.getElementById("app") || document.body,
            canvasWidth: 300, // 足够宽，容纳旋转后的11位手机号
            canvasHeight: 120,
            fontSize: 16,
            fillStyle: "rgba(184, 184, 184, 0.3)",
            content,
            rotate: -25,
            zIndex: 10000,
        });
    };

    // 确保DOM加载完成
    if (document.readyState === "complete") {
        init();
    } else {
        window.addEventListener("load", init, { once: true });
    }
};

export default addWatermark;